import * as React from "react";
import { _MasterDetailView, } from "../generic/master-detail-view/MasterDetailView";
import { DetailViewNursery } from "./DetailViewNursery";
import { MasterViewNursery } from "./MasterViewNursery";
export var TabNursery = function () {
    var MasterDetailView = _MasterDetailView;
    return (React.createElement(MasterDetailView, { masterRenderer: MasterViewNursery, detailRenderer: DetailViewNursery }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/TabNursery.tsx
// module id = 2726
// module chunks = 3